































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Scrollbar, Select, Option,
} from 'element-ui';
import NProgress from 'nprogress';
import Devisive from '@/servers/modules/decisive/index'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import learning from './essayModel/learning.vue';
import detail from './essayModel/detail.vue';

export interface classNode {
  label: string,
  value: string,

  orderNum: string,
  nodeType: string,
  nodeName: string,
  nodeInstanceId: number,
  nodeId: number,
  nodeGroupId: number,
  children: classNode[] | null
}

interface nodeTree {
  value: string,
  options: any
}

@Component({
  components: {
    Scrollbar,
    Button,
    Select,
    Option,
    learning,
    detail,
  },
})
export default class extends Vue {
  // @value 2 : 学习分析
  // @value 1 : 学习报告(回顾复习)
  private classType = 1;

  // 回顾复习-列表排列方式
  private mastery: string = '0';

  // 目录树配置
  private defaultProps = {
    children: 'children',
    label: 'nodeName',
  };

  // 目录切换内容
  private calendar: nodeTree = {
    value: '',
    options: [],
  };

  // @ts-ignore 课程名称
    @Getter public basicData: any;

    // ----------------------------------初始化
    private created() {
      NProgress.start();
      this.init();
    }

    private async init() {
      NProgress.done();
      if (this.$route.query.classType) {
        this.classType = +this.$route.query.classType;
        this.handleToggleType(this.classType);
      }
      if (this.$route.query.mastery) {
        this.mastery = `${this.$route.query.mastery}`;
      }
      // 获取学习目录内容
      this.studyAnalysisDirectoryList();
    }

    // 目录
    private async studyAnalysisDirectoryList() {
      function myDataFilter(data: any[]) {
        data.forEach((item: classNode) => {
          console.log(item);
          item.label = item.nodeName;
          item.value = JSON.stringify(item);
          if (item.children && item.children.length > 0) {
            myDataFilter(item.children);
          }
        });
        return data;
      }

      const form = {
        processInstanceId: window.LS.get('jse_data').processInstanceId,
      };
      const res = await Devisive.studyAnalysisDirectoryList(form).catch((e) => {
        console.log(e);
      });
      if (!res.data.code) {
        this.calendar.options = myDataFilter(res.data.data);
        if (this.$route.query.select) {
          const selectNode = window.LS.get('selectNode');
          console.log('selectNode', selectNode);
          this.calendar.value = selectNode.value;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(selectNode.orderNum);
          });
        } else {
          this.calendar.value = this.calendar.options[0].children[0].value;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.calendar.options[0].children[0].orderNum);
          });
        }
        console.log('this.calendar.options', this.calendar.options);
        this.handleToggleNode();
      }
    }

    // ----------------------------------操作
    // 切换学习报告(回顾复习)和学习分析
    private handleToggleType(type: number) {
      this.classType = type;
      this.handleToggleNode();
    }

    // 切换学习报告(回顾复习)排序
    private handleReviewSort() {
      this.handleToggleNode();
    }

    // 切换课程节点
    private handleToggleNode(data?: classNode) {
      console.log('data-----', data);
      console.log('this.calendar-----', this.calendar);
      if (data && data.value) {
        this.calendar.value = data.value;
        window.LS.set('selectNode', data);
      }
      console.log(this.calendar);
      if (!this.calendar.value) {
        return false;
      }
      // 调用子组件方法进行更新页面
      const node: classNode = JSON.parse(this.calendar.value);
      console.log('node', node);
      // 学习报告(回顾复习)
      if (this.classType == 1) {
        if (node.nodeType == 'EXTRA') {
          this.$refs.learning.init(node.nodeGroupId || '', this.mastery, node.nodeType);
        } else {
          this.$refs.learning.init(node.nodeId || '', this.mastery, node.nodeType);
        }
      }
      // 学习分析
      else {
        this.$refs.detail.isShowNode(node);
      }
    }

    // 回到课程首页
    private go() {
      this.$router.push('/');
    }
}
